export default {
  login: {
    loginTitle: '登录账号',
    loginInfo: '',
    email:'邮箱',
    emailPlaceholder: '请输入E-mail',
    passwdPlaceholder: '请输入密码',
    forgetPasswd: '忘记密码？',
    loginBtn: '登录',
    register: '新用户注册',
    registerInfo: '邮箱注册成功后，将无法修改！建议您填写您的私人邮箱。',
    registerProtocol: '同意注册协议，点击阅读。',
    registerBtn: '立即注册',
    forget: '忘记密码',
    remember: '七天内免登录',
    return: '返回',
    mailerror: '邮箱格式不正确',
    check: '请先勾选用户协议才能进行下一步操作',
    emailMessage: 'E-mail不能为空',
    passwdMessage: '密码不能为空',
    emailNotNull: '邮箱不能为空',
    agree: '请先阅读并同意KaryShop用户协议和隐私政策',
  },
  NL: '荷兰',
  DE: '德国',
  BE: '比利时',
  LU: '卢森堡',
	FR: '法国'
}


// WEBPACK FOOTER //
// ./resources/js/lib/i18n/zh/header.js